module.exports = "<div class=\"training-tree\">\n  <app-intelcia-tree [nodes]=\"nodes\" [onNodes]=\"onActivate()\" [search]=\"true\"></app-intelcia-tree>\n<!--  <tree-root *ngIf=\"nodes?.length > 0\"\n      [nodes]=\"nodes\"\n      [options]=\"options\"\n      (activate)=\"onActivate($event)\">\n      <ng-template #treeNodeTemplate let-node let-index=\"index\">\n          <span [ngClass]=\"node.data.classes\">{{ node.data.name }}</span>\n      </ng-template>\n  </tree-root>-->\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/view/training-tree/training-tree.component.html
// module id = ./src/app/view/training-tree/training-tree.component.html
// module chunks = main